import { render, staticRenderFns } from "./inviteRegister.vue?vue&type=template&id=38c78033&scoped=true&"
import script from "./inviteRegister.vue?vue&type=script&lang=js&"
export * from "./inviteRegister.vue?vue&type=script&lang=js&"
import style0 from "./inviteRegister.vue?vue&type=style&index=0&id=38c78033&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c78033",
  null
  
)

export default component.exports